export enum DurationDataHooks {
  DURATION = 'booking-details-duration',
}
